export const STEP_SETUP_ENVIRONMENT = 'STEP_SETUP_ENVIRONMENT';
export const STEP_CREATE_ORDER = 'STEP_CREATE_ORDER';
export const STEP_CONFIGURE_WIDGET = 'STEP_CONFIGURE_WIDGET';
export const STEP_RESULT = 'STEP_RESULT';


export const STEP_STATUS_READY = 'step-ready text-primary2';
export const STEP_STATUS_CURRENT = 'step-current text-primary';
export const STEP_STATUS_NEXT = 'step-next text-gray';


// WEBPACK FOOTER //
// ./src/steps/StepsContants.js